import module from 'viaticos/module.js'

export const schema = {
  deducible: 'boolean',
  fecha: 'date',
  id_moneda: 'number',
  subtotal: 'number',
  tipo_cambio: 'number',
  propina: 'number',
  total: 'number',
  total_impuestos_retenidos: 'number',
  total_impuestos_trasladados: 'number',
  autorizado: 'boolean',
  maquilado: 'boolean',
  preautorizado: 'boolean',
  timbre_id: 'number',
  xml: {
    archivo_id: 'number',
  },
  pdf: {
    archivo_id: 'number',
  },
}

export const schemaPost = {
  solicitud_id: 'number',
  importe: 'number',
  propina: 'number',
  total: 'number',
  autorizado: 'boolean',
  cancelado: 'boolean',
  maquilado: 'boolean',
  eliminado: 'boolean',
  pagado: 'boolean',
  timbrado: 'boolean',
  preautorizado: 'boolean',
  fecha: 'datetime',
  indice: 'number',
  editable: 'boolean',
  eliminable: 'boolean',
  tipo_id: 'number',
  ultimo: 'boolean',
  acceso_autorizar: 'boolean',
  acceso_maquilar: 'boolean',
  acceso_proyecto: 'boolean',
  acceso_solicitar: 'boolean',
  acceso_eliminar: 'boolean',
  autorizaciones: {
    fecha_autorizacion: 'datetime',
    correo_enviado_fecha: 'date',
    autorizado: 'boolean',
    cancelado: 'boolean',
    correo_enviado: 'boolean',
    indice: 'number',
    maximo: 'number',
    posicion: 'number',
    usuario_id: 'number',
    tipo_id: 'number',
  },
  comprobantes: {
    comprobante_id: 'number',
    deducible: 'boolean',
    fecha: 'date',
    moneda_id: 'number',
    subtotal: 'number',
    tipo_cambio: 'number',
    propina: 'number',
    total: 'number',
    total_impuestos_trasladados: 'number',
    total_impuestos_retenidos: 'number',
  },
}

export class ViaticosViaticoComprobanteService {
  constructor ($http, $schema) {
    this.$http = $http
    this.$schema = $schema
  }

  get (comprobanteId) {
    return this.$http.get('api/viaticos/viaticos/viatico/comprobante', {
      params: {
        comprobante_id: comprobanteId,
      },
      schema,
    })
  }

  post (data, comprobanteId) {
    let formData = new FormData()
    formData.set('data', JSON.stringify(data.data))
    if (data.xml) {
      formData.set('xml', data.xml.file)
    }
    if (data.pdf) {
      formData.set('pdf', data.pdf.file)
    }
    return this.$http.post('api/viaticos/viaticos/viatico/comprobante', formData, {
        params: {
          comprobante_id: comprobanteId,
        },
      })
      .then((response) => ({...response, data: this.$schema(response.data, schemaPost, false)}))
  }
}

module.service('ViaticosViaticoComprobanteService', ViaticosViaticoComprobanteService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Viatico/Comprobante.js